export enum TeamParticipantEnum {
    Creator = 0,
    Player = 1,
    Manager = 2,
    Captain = 3,
    ContentMaker = 4,
    Coach = 5,
    Owner = 6
}